import {HTTP} from '@/router/http';

// initial state
const state = {
	datasets:[],
	current_dataset:{},
	lists:[],
	genes:[],
	proposed_genes:[],
	current_gene:{},
	colors:['#edc951','#00a0b0', '#eb6841', '#cc2a36', '#4f372d',  '#419873','#c79dd7','lightgrey'],
}

// getters
const getters = {
	datasets: state => state.datasets,
	dataset: state => state.current_dataset,
	genes: state => state.genes,
	colors: state => state.colors,
	lists: state => state.lists,
	proposed_genes: state => state.proposed_genes,
	current_gene: state => state.current_gene
}

// actions
const actions = {
	getDatasets ({ commit,state }) {
		if (!state.datasets.length){		
			return new Promise((resolve, reject) => {	
				HTTP.get('/datasets').then(res => {
					commit('SET_DATASETS', res.data)
				}).catch(err => reject(err));
			});
		}
	},
	getDataset ({ commit },dataset_id) {
		return new Promise((resolve, reject) => {
			HTTP.get('/dataset/'+dataset_id).then(res => {
				commit('SET_DATASET', res.data)
			}).catch(err => reject(err));
		});
	},
	
	getLists ({ commit,state }) {
		if (!state.lists.length){		
			return new Promise((resolve, reject) => {
				HTTP.get('/lists').then(res => {
					commit('SET_LISTS', res.data)
				}).catch(err => reject(err));
			});
		}
	},
	getGeneLists ({ commit,state }) {
		if (!state.lists.length){		
			return new Promise((resolve, reject) => {
				HTTP.get('/gene_lists').then(res => {
					commit('SET_GENE_LISTS', res.data)
				}).catch(err => reject(err));
			});
		}
	},
	getGenes ({ commit,state},params) {
		state.proposed_genes = [];
		return new Promise((resolve, reject) => {
			let param_string = "?format="+params.format + "&symbol="+params.symbol;	
			HTTP.get('/genes'+param_string).then(res => {
				commit('SET_PROPOSED_GENES', res.data)
				resolve(res.data);
			}).catch(err => reject(err));
		});
	},
	getGene ({ commit,state},gene) {
		if (!gene.ensemblID){
			commit('RESET_GENE')
		}
		else{			
			return new Promise((resolve, reject) => {
				HTTP.get('/gene/'+gene.ensemblID).then(res => {
					commit('SET_GENE', res.data)
					resolve(res.data);
				}).catch(err => reject(err));
			});
		}
	},
	resetGene ({ commit,state},gene) {
		commit('RESET_GENE')
	},
}

// mutations
const mutations = {
	SET_DATASETS (state, datasets) {
		state.datasets = datasets
	},
	SET_DATASET (state, dataset) {
		dataset.files = _.keys(dataset.data);
		state.current_dataset = dataset
	},
	SET_LISTS (state, lists) {
		state.lists = lists
	},
	SET_GENE_LISTS (state, genes) {
		state.genes = genes
	},
	SET_PROPOSED_GENES (state, genes) {
		state.proposed_genes = genes;
	},
	SET_GENE (state, gene) {
		gene.groupByTypes = {};
		gene.dataset_names = _.keys(gene.datasets);
		_.forEach(state.datasets,function(d){
			if (gene.dataset_names.indexOf(d.name)>-1){
				_.forEach(d.variables,function(v){
					if (!gene.groupByTypes[v.name]) gene.groupByTypes[v.name] = {name:v.name,data:[]};
					_.forEach(v.values,function(val){
						let fval = (isNaN(val)) ? val : +val;
						if (gene.groupByTypes[v.name].data.indexOf(fval)<0){
							gene.groupByTypes[v.name].data.push(fval);
						}
					})

				})
			}
		})
		state.current_gene = gene;
	},
	RESET_GENE (state) {
		state.current_gene = {};
	},

}

export default {
	state,
	getters,
	actions,
	mutations
}